import React, { useState, useEffect } from "react";
import "./newSideBar.css";
import { NavLink } from "react-router-dom";


import { MdDashboard, MdComputer } from "react-icons/md";
import { BiUserCheck, BiMessageSquareAdd } from "react-icons/bi";
import { RiBarChartHorizontalFill,  } from "react-icons/ri";
import { GoSignOut } from "react-icons/go";
import { FaNewspaper,FaSearchengin } from "react-icons/fa";



// import {
  
//   GoSignOut,
//   ,
//   MdComputer,
//   ,
//   ,
//   ,
// } from "react-icons/all";
import { useSelector, useDispatch } from "react-redux";

import Cookies from "js-cookie";

const NewSideBar = () => {
  let [sideBoxClass, setSideBoxClass] = useState("SidemainBox");
  let [sideList, setSideList] = useState("sideList");
  let [flag, setFlag] = useState(true);
  let [scrollSize, setScrollSize] = useState(window.innerWidth);

  const { adminInfo, loadings } = useSelector(
    (state) => state.readAdminAuthReducer
  );
  const logOut = () => {
    // alert("asdsadsa");
    // localStorage.clear();
    Cookies.remove("token");
  };
  useEffect(() => {
    if (scrollSize < 768) {
      setSideBoxClass("SidemainBox hide");
      setSideList("sideList sideListHide");
      setFlag(false);
    } else if (scrollSize > 768) {
      setSideBoxClass("SidemainBox");
      setTimeout(() => {
        setSideList("sideList");
      }, 500);
      setFlag(true);
    }
  }, [scrollSize]);

  window.addEventListener("resize", () => {
    setScrollSize(window.innerWidth);
  });

  const sideBarHide = () => {
    if (flag) {
      setSideBoxClass("SidemainBox hide");
      setSideList("sideList sideListHide");
      setFlag(false);
    } else {
      setSideBoxClass("SidemainBox");
      setTimeout(() => {
        setSideList("sideList");
      }, 500);
      setFlag(true);
    }
  };

  return (
    <>
   
      <div className={sideBoxClass}>
        
        
        <section className="sideBArBtn">
          <span>
            <RiBarChartHorizontalFill onClick={sideBarHide} />
          </span>
        </section>

        <section className={sideList}>
          <div>
            <div className="linkdiv">
            <NavLink
              to="/mainadmindashboard"
              style={{ textDecoration: "none" }}
            >
              <div>
                <MdDashboard color="#016738" size={25}/> <span>DASHBOARD</span>
              </div>
            </NavLink>
            <div className="underlinediv"></div>

            </div>
            <div className="linkdiv">
            <NavLink to="/regstddata" style={{ textDecoration: "none" }}>
              <div>
                <FaSearchengin color="#016738" size={25}/>
                <span>Registeration Data</span>
              </div>
            </NavLink>
            </div>
            <div className="linkdiv">
            <NavLink to="/adminassignments">
            <div>
              <MdComputer color="#016738" size={25}/>
              <span>Assignments</span>
            </div>
            </NavLink>
            </div>
            <div className="linkdiv">
            <NavLink to="/addassignment">
            <div>
              <MdComputer color="#016738" size={25}/>
              <span>Add Assignments</span>
            </div>
            </NavLink>
            </div>
            <div className="linkdiv">
            <NavLink to="/createquiz" style={{ textDecoration: "none" }}>
              <div>
                <FaNewspaper color="#016738" size={25}/>
                <span>Create Quiz</span>
              </div>
            </NavLink>
            </div>
            <div className="linkdiv">
              <NavLink to="/UpdateQuiz" style={{ textDecoration: "none" }}>
                <div>
                  <FaNewspaper color="#016738" size={25}/> <span>Update Quiz</span>
                </div>
              </NavLink>
              </div>
              <div className="linkdiv">
              <NavLink to="/addcourse" style={{ textDecoration: "none" }}>
                <div>
                  <BiMessageSquareAdd color="#016738" size={25}/>
                  <span> Add Course</span>
                </div>
              </NavLink>
              </div>
              <div className="linkdiv">
              <NavLink to="/courseList" style={{ textDecoration: "none" }}>
                <div>
                  <BiMessageSquareAdd color="#016738" size={25}/>
                  <span>Course List</span>
                </div>
              </NavLink>
              </div>
            <div className="linkdiv">
              <NavLink to="/addattendance" style={{ textDecoration: "none" }}>
            <div>
              <BiUserCheck color="#016738" size={25}/> <span>Attendance</span>
            </div>
            </NavLink>
            </div>
             
            <div className="linkdiv">
            <NavLink
              to="/adminlogin"
              onClick={logOut}
              style={{ textDecoration: "none" }}
            >
              <div>
                <GoSignOut color="#016738" size={25} onClick={() => logOut()} />
                <span>SignOut</span>
              </div>
            </NavLink>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NewSideBar;
